import React from "react";
import { Card, Button } from "antd";
import { useNotificationStore } from "../notifications.store";

const TemplatePreview: React.FC = () => {
  const { selectedTemplate, openTemplateModal } = useNotificationStore();
  return (
    <Card title="Template Preview">
      <div className="h-full bg-[#fafafa] p-4 rounded-lg">
        {!selectedTemplate ? (
          <div className="h-full text-center text-[#8c8c8c]">
            No template selected
          </div>
        ) : (
          <>
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>
                Subject
              </div>
              <div style={{ fontWeight: 500 }}>{selectedTemplate.subject}</div>
            </div>
            <div>
              <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>
                Body
              </div>
              <div style={{ fontSize: 14, whiteSpace: "pre-line" }}>
                {selectedTemplate.body}
              </div>
            </div>
          </>
        )}
      </div>
      {selectedTemplate && (
        <div className="flex justify-end mt-4">
          <Button onClick={() => openTemplateModal(selectedTemplate.id)}>
            Edit Template
          </Button>
        </div>
      )}
    </Card>
  );
};

export default TemplatePreview;
